import { useMessaging, useDictionary } from "@adamlip/okeoke.client"
import { Button, ButtonGroup } from "@nextui-org/react"
import { useEffect, useState } from "react"
import NewsCard from "./NewsCard"
import moment from "moment"
import { scroller } from "react-scroll"
import { useParams } from "react-router-dom"

export default function NewsFeed() {
  const { getValue } = useDictionary()
  const { id } = useParams()

  const { messagingLoggedIn, articles } = useMessaging()

  //console.log(articles);

  const [onlyUnRead, setOnlyUnRead] = useState(true)
  const [onlyHighSeverity, setOnlyHighSeverity] = useState(false)

  const sortFunction = (a, b) => {
    return moment(a.updateTimestamp).isAfter(b.updateTimestamp) ? -1 : 1
  }

  const filterFunction = (news) => {
    let response = true
    if (onlyUnRead) {
      if (onlyHighSeverity) {
        response = news.seen === 0 && news.severity > 0
      } else {
        response = news.seen === 0
      }
    } else {
      if (onlyHighSeverity) {
        response = news.severity > 0
      }
    }
    return response
  }

  const handleSetOnlyUnRead = (value) => {
    localStorage["newsfeed.onlyUnRead"] = value
    setOnlyUnRead(value)
  }

  const handleSetOnlyHighSeverity = (value) => {
    localStorage["newsfeed.onlyHighSeverity"] = value
    setOnlyHighSeverity(value)
  }

  useEffect(() => {
    setOnlyUnRead(localStorage["newsfeed.onlyUnRead"] === "true")
    setOnlyHighSeverity(localStorage["newsfeed.onlyHighSeverity"] === "true")
  }, [])

  useEffect(() => {
    if (id) {
      const options = {
        duration: 1500,
        delay: 100,
        smooth: true,
        containerId: "news-container",
        offset: -40,
      }
      setTimeout(() => {
        scroller.scrollTo(id, options)
      }, 100)
    }
    //eslint-disable-next-line
  }, [])

  if (!messagingLoggedIn)
    return (
      <div className="text-center mt-4">
        {getValue("app_v2_newsfeed_not_available")}
      </div>
    )

  return (
    <div className={`newsFeed-root p-2 h-full flex flex-col`}>
      <div className="mt-1 mb-2 flex justify-center w-full overflow-auto shrink-0">
        <ButtonGroup fullWidth>
          <Button
            color={`${onlyUnRead ? "primary" : "default"}`}
            onPress={() => handleSetOnlyUnRead(true)}
          >
            {getValue("app_v2_newsfeed_not_read")}
          </Button>
          <Button
            color={`${!onlyUnRead ? "primary" : "default"}`}
            onPress={() => handleSetOnlyUnRead(false)}
          >
            {getValue("app_v2_newsfeed_all")}
          </Button>
          <Button
            color={`${onlyHighSeverity ? "warning" : "default"}`}
            onPress={() => handleSetOnlyHighSeverity(!onlyHighSeverity)}
          >
            {getValue("app_v2_newsfeed_high_severity")}
          </Button>
        </ButtonGroup>
      </div>
      <div
        className={`flex-grow pb-96 overflow-auto md:flex md:gap-2 md:flex-wrap`}
        id="news-container"
      >
        {(articles || []).filter(filterFunction).length < 1 && (
          <div className="w-full text-center mt-4">
            {getValue("app_v2_newsfeed_no_article")}.
          </div>
        )}
        {(articles || [])
          .filter(filterFunction)
          .sort(sortFunction)
          .map((article) => (
            <NewsCard key={article.uid} data={article} />
          ))}
      </div>
    </div>
  )
}
